// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getCancellationReasonById } from 'app/constants/enums/CancellationReason/main';

/* eslint-disable max-len */
export const AUTOMATIC_ABSENCE = getCancellationReasonById('automaticAbsence');
export const AUTOMATIC_PARTIAL_ABSENCE = getCancellationReasonById('automaticPartialAbsence');
export const CONNECTION = getCancellationReasonById('connection');
export const EQUIPMENT = getCancellationReasonById('equipment');
export const HEALTH = getCancellationReasonById('health');
export const LATE_MANUAL = getCancellationReasonById('lateManual');
export const LEGACY = getCancellationReasonById('legacy');
export const MANUAL = getCancellationReasonById('manual');
export const OFFICE = getCancellationReasonById('office');
export const OTHER = getCancellationReasonById('other');
export const PERSONAL = getCancellationReasonById('personal');
export const POWER = getCancellationReasonById('power');
export const READY_BUTTON = getCancellationReasonById('readyButton');
export const SELF_BOOKING = getCancellationReasonById('selfBooking');
export const SKYPE = getCancellationReasonById('skype');
export const STAFF_RECORDED_ABSENCE = getCancellationReasonById('staffRecordedAbsence');
export const STUDENT_ACCOUNT_CLOSE = getCancellationReasonById('studentAccountClose');
export const TEACHER_ACCOUNT_CLOSE = getCancellationReasonById('teacherAccountClose');
export const TEACHER_RECORDED_ABSENCE = getCancellationReasonById('teacherRecordedAbsence');
/* eslint-enable max-len */
